module.exports = __webpack_public_path__ + "img/card-with-slider-rivoneed.b4dbe2fb.webp";